import { CommonModule, TitleCasePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import * as echarts from 'echarts';
import { DashboardService } from './dashboard.service';
import { DashboardQuoteSummary } from './dashboard-data.resolver';

@Component({
  selector: 'app-dashboard',
  imports: [CommonModule, RouterLink, TitleCasePipe],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  service: DashboardService = inject(DashboardService);
  data: DashboardQuoteSummary[] = [];

  @ViewChild('chart', { static: true }) chart!: ElementRef;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.drawChart();
    this.data = this.route.snapshot.data['dashboardData'];
  }

  quote_link(quote_id: string, quote_type: number) {
    if (quote_type == 2) {
      return `/quotes/maintenance/${quote_id}`;
    }

    return `/quotes/${quote_id}`;
  }

  getQuoteTypeName(quoteType: number): string {
    if (quoteType === 2) {
      return 'Maintenance';
    }

    return 'Standard';
  }

  drawChart() {
    const chart = echarts.init(this.chart.nativeElement);
    chart.setOption({
      tooltip: {
        trigger: 'item',
      },
      legend: {
        orient: 'vertical',
        left: 'left',
      },
      series: [
        {
          name: 'Quote Status',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            show: false,
            position: 'center',
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 12,
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: 1048, name: 'In Progress' },
            { value: 735, name: 'Pending Approval' },
            { value: 580, name: 'Won' },
            { value: 484, name: 'Lost' },
          ],
        },
      ],
    });
  }
}
